import script from "./SubmitStoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitStoryView.vue?vue&type=script&setup=true&lang=js"

import "./SubmitStoryView.vue?vue&type=style&index=0&id=2c661fa0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c661fa0"]])

export default __exports__